import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'
import { H2, Text1 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'

const ApplicationEntry: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Layout header={<AppBarCommon />}>
      <CenteredContainer header={<H2>{t('お申込みが完了しました')}</H2>}>
        <Text1>
          {t('登録されたアドレス宛に、利用開始に関するメールが送信されます。')}
        </Text1>
        <Text1>{t('メールを確認してください。')}</Text1>
      </CenteredContainer>
    </Layout>
  )
}

export default ApplicationEntry
